
namespace PaperTrail.NewsletterControl {

    @Serenity.Decorators.registerClass()
    export class PageTemplateDialog extends Serenity.EntityDialog<PageTemplateRow, any> {
        protected getFormKey() { return PageTemplateForm.formKey; }
        protected getIdProperty() { return PageTemplateRow.idProperty; }
        protected getLocalTextPrefix() { return PageTemplateRow.localTextPrefix; }
        protected getNameProperty() { return PageTemplateRow.nameProperty; }
        protected getService() { return PageTemplateService.baseUrl; }
        protected getDeletePermission() { return PageTemplateRow.deletePermission; }
        protected getInsertPermission() { return PageTemplateRow.insertPermission; }
        protected getUpdatePermission() { return PageTemplateRow.updatePermission; }

        protected form = new PageTemplateForm(this.idPrefix);
        protected nldialog = new NewsletterDialog();


        // Save the customer and the order 
        protected saveTemplate(callback: (response: Serenity.SaveResponse) => void, onSuccess?: (response: Serenity.SaveResponse) => void): boolean {
            //this.entity.AdsSpots = this.form.AdsSpots.get_value();
            //this.entity.FileName = this.form.FileName.value;
            ////this.entity.IsFrontPage = this.form.IsFrontPage.get_value();
            //this.entity.NewsSpots = this.form.NewsSpots.get_value();
            //this.entity.TemplateSections = this.form.TemplateSections.value;
            //this.entity.Title = this.form.Title.value; 
            


            return true;
        }

        protected onDialogOpen() {
            super.onDialogOpen();

            var prior = $(".ui-dialog").eq(-2);
            if (prior.length > 0) {
                prior.change();
                Serenity.SubDialogHelper.cascade(this, prior);
            }
        }

        protected saveAll(callback: (response: Serenity.SaveResponse) => void) {
            this.saveTemplate(callback,
                // If customer successa, save Order entity
                resp => Q.notifySuccess("good!")
            );
        }

        // This is called when save/update button is pressed
        protected save(callback: (response: Serenity.SaveResponse) => void) {
            NewsletterControl.PageTemplateService.Update({
                EntityId: this.entityId,
                Entity: this.getSaveEntity()
            }, response => {
                // reload customer list just in case
                Q.reloadLookup(NewsletterControl.PageTemplateRow.lookupKey);
                //Q.reloadLookup(NewsletterControl.NewsletterRow.lookupKey);
                Q.reloadLookup(NewsletterControl.NewsletterPageTemplateRow.lookupKey);

                // set flag that we are triggering customer select change event
                // otherwise active tab will change to first one
                //this.selfChange++;
                try {
                    // trigger change so that customer select updates its text
                    // in case if Company Name is changed
                    this.form.PageTemplateId.element.change();
                }
                finally {
                    //this.selfChange--;
                }
                //return true;
            });

            var prior = $(".ui-dialog").eq(-2);
            var prior2 = $(".ui-dialog").eq(-1);
            prior.trigger("changeme");
            prior2.trigger("changeme");
            if (prior.length > 0) {
                prior.change();
                Serenity.SubDialogHelper.cascade(this, prior);
            } 
            super.save(callback);
        }
    }
}